import { makeFormatNumber, parseFormatedNumber } from './numberformat'

export const formatKronur = (value?: number): string => (Boolean(value) ? makeFormatNumber()(value) : '0')

export const parseKronur = (value: string) => parseFormatedNumber(value)
